import { Record } from "immutable";

import { OUTLINE_VIEW,SPREADSHEET_VIEW } from "../../../../constants/identifiers";
import createFromJS from "../../../createFromJS";
import { defaultColumnsForOutlineView } from "../appState/defaultColumnsForOutlineView";
import { defaultColumnsForSpreadsheetView } from "../appState/defaultColumnsForSpreadsheetView";

export const DefaultColumnsRecord = Record({
  [SPREADSHEET_VIEW]: defaultColumnsForSpreadsheetView,
  [OUTLINE_VIEW]: defaultColumnsForOutlineView
});

const data = {
  collections: {
    [SPREADSHEET_VIEW]: "TableViewColumnRecord",
    [OUTLINE_VIEW]: "TableViewColumnRecord"
  }
};
createFromJS.registerCallback("DefaultColumnsRecord", createFromJS.createNestedCallback(DefaultColumnsRecord, data));
